// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Swiper from 'swiper'
import VueI18n from 'vue-i18n'
import 'swiper/dist/css/swiper.css'
import '../static/main.css';


import elementUI from 'element-ui'; 
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(elementUI)

// 引入配置的svg配置的js文件
// import './icons'

// 引入iconfont配置的css文件
import './assets/iconfont/iconfont.css'

Vue.config.productionTip = false

// 引入http请求
import $http from './service/index';
Vue.prototype.$http = $http;

// 引入國際化插件
Vue.use(VueI18n)
var language = localStorage.getItem('language')
const i18n = new VueI18n({
  // 設置默認語言
  locale: language == null || language == 'zh' ? 'zh' : 'en',
  // 語言文件地址
  messages: {
    'zh': require('@/assets/Language/zh.json'),
    'en': require('@/assets/Language/en.json')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js